import { render, staticRenderFns } from "./ycjl.vue?vue&type=template&id=b6ccb696&scoped=true"
import script from "./ycjl.vue?vue&type=script&lang=js"
export * from "./ycjl.vue?vue&type=script&lang=js"
import style0 from "./ycjl.vue?vue&type=style&index=0&id=b6ccb696&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6ccb696",
  null
  
)

export default component.exports